var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-623.000000, -928.000000)",
    fill: "#8298AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Logout",
    transform: "translate(90.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37499195,5.50003219 L9.32810991,5.50003219 C9.56012688,5.50003219 9.74998391,5.68988922 9.74998391,5.92190618 L9.74998391,6.76565417 C9.74998391,6.99767113 9.56012688,7.18752816 9.32810991,7.18752816 L6.37499195,7.18752816 C5.44335355,7.18752816 4.68749598,7.94338574 4.68749598,8.87502414 L4.68749598,15.625008 C4.68749598,16.5566465 5.44335355,17.312504 6.37499195,17.312504 L9.32810991,17.312504 C9.56012688,17.312504 9.74998391,17.5023611 9.74998391,17.734378 L9.74998391,18.578126 C9.74998391,18.810143 9.56012688,19 9.32810991,19 L6.37499195,19 C4.51171515,19 3,17.4882849 3,15.625008 L3,8.87502414 C3,7.01174733 4.51171515,5.50003219 6.37499195,5.50003219 Z M14.4995682,6.18557743 C14.6648091,6.02033658 14.9320165,6.02033658 15.097223,6.18207554 L20.8769105,11.9476868 C21.0421514,12.1128933 21.0421514,12.3801008 20.8769105,12.5453416 L15.097223,18.3109529 C14.9320165,18.4761594 14.6648091,18.4761594 14.4995682,18.3109529 L13.8105211,17.6218714 C13.6452803,17.4566306 13.6488165,17.1859556 13.8175592,17.0207147 L17.7937079,13.1640764 L9.04686058,13.1640764 C8.81484362,13.1640764 8.62498659,12.9742194 8.62498659,12.7422024 L8.62498659,11.7578298 C8.62498659,11.5258128 8.81484362,11.3359558 9.04686058,11.3359558 L17.7937079,11.3359558 L13.8175592,7.47581559 C13.6452803,7.31407663 13.6417784,7.04340161 13.8105211,6.87462455 L14.4995682,6.18557743 Z",
    id: "\\uF08B"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0ed7819f.svg";
export { ForwardRef as ReactComponent };